export const MADAME = 'MADAME';
export const MONSIEUR = 'MONSIEUR';



// WEBPACK FOOTER //
// ./src/constants/civilities.js